import { selectUser } from './selectUser';
import { IState } from '../../../store';

export const selectIsAuthenticated = (state: IState) => selectUser(state)?.isAuthenticated || false;
